/* src/app/modules/periods/period/period.component.scss */
/*# sourceMappingURL=period.component.css.map */
